const features = {
  emailSync: {
    id: 1,
    description: 'email sync',
  },
  calendarSync: {
    id: 2,
    description: 'calendar',
  },
  contactSync: {
    id: 3,
    description: 'contact',
  },
  emailSend: {
    id: 4,
    description: 'email send'
  },
};

export default features;
